<template>
  <div class="consumer-layout">
    <div class="main-header">
      <div class="header">
        <Swiper
          v-if="topTextBannerDatas.length > 0"
          :key="`top-text-${topTextBannerDatas.length}`"
          class="top-text-banner-swiper"
          :modules="[Autoplay]"
          direction="vertical"
          :slides-per-view="1"
          :loop="topTextBannerDatas.length > 1"
          :autoplay="
            topTextBannerDatas.length > 1
              ? { delay: 5000, disableOnInteraction: false }
              : false
          "
          :allow-touch-move="false"
        >
          <SwiperSlide v-for="item in topTextBannerDatas" :key="item.id">
            <a
              v-if="isExternalLink(item.redirect)"
              :href="item.redirect"
              target="_blank"
              rel="noopener noreferrer"
              :style="`color: ${item.color}; background-color: ${item.backgroundColor}`"
            >
              {{ item.content }}
            </a>

            <router-link
              v-else
              :to="item.redirect || '/'"
              :style="`color: ${item.color}; background-color: ${item.backgroundColor}`"
            >
              {{ item.content }}
            </router-link>
          </SwiperSlide>
        </Swiper>
      </div>
      <hr />
      <header>
        <div class="main-header">
          <router-link to="/" class="home-btn">
            <img src="@/assets/logo.png" alt="logo" />
          </router-link>
          <div class="search-bar">
            <input
              type="text"
              placeholder="검색어를 입력해주세요."
              v-model="searchKeyword"
              @keyup.enter="handleSearch"
            />
            <button @click="handleSearch">
              <span class="material-icons-outlined"> search </span>
            </button>
          </div>
          <div class="user-info">
            <router-link to="/mypage" v-if="isLogged">
              <span class="material-icons-outlined"> person </span>
              <p>MY</p>
            </router-link>
            <router-link to="/cart" v-if="isLogged">
              <span class="material-icons-outlined"> shopping_cart </span>
              <p>CART</p>
            </router-link>
            <button @click="logout" v-if="isLogged">
              <span class="material-icons-outlined"> logout </span>
              <p>LOGOUT</p>
            </button>
            <router-link to="/login" v-else>
              <span class="material-icons-outlined"> login </span>
              <p>LOGIN</p>
            </router-link>
          </div>
        </div>
        <hr />
        <div class="category-container">
          <nav class="main-category-nav">
            <router-link
              v-for="item in categoryDatas"
              :key="item.id"
              :to="`/list?category=${item.id}`"
              >{{ item.title }}</router-link
            >
          </nav>
          <nav class="sub-category-nav" v-if="subCategoryDatas.length > 0">
            <router-link
              v-for="item in subCategoryDatas"
              :key="item.id"
              :to="`/list?category=${item.id}`"
              >{{ item.title }}</router-link
            >
          </nav>
        </div>
      </header>
    </div>
    <div class="content"><router-view></router-view></div>
    <footer>
      <div class="footer-content">
        <div>
          <img src="@/assets/logo.png" />
          <p class="f-info mt">
            회사명: 냥이네구름가게 | 주소: 대구광역시 남구 계명중앙1길 17
          </p>
          <p class="f-info">
            대표자: 김원재 | 전화: 070-4047-4096 | 개인정보관리책임:
            김원재(ceo@necokumo.co.kr)
          </p>
          <p class="f-info">
            사업자등록번호: 228-15-02857 | 통신판매업 신고: 2025-대구남구-0495
          </p>
          <p class="f-info mt">
            Copyrightⓒ 2025 냥이네구름가게. All rights reserved.
          </p>
        </div>
        <div>
          <div>
            <h3>고객센터</h3>
            <h2 class="mt">070-4047-4096</h2>
            <p class="f-info mt">연중무휴 : 09:30- ~ 03:00</p>
            <p class="f-info">주말 및 공휴일에는 택배가 출고되지 않습니다.</p>
            <h3 class="mt">교환 & 반품주소</h3>
            <p class="f-info mt">대구 남구 계명중앙1길 17</p>
          </div>
          <div>
            <h3>무통장입금 안내</h3>
            <p class="f-info mt">토스 1002-2582-0340</p>
            <p class="f-info mt">예금주 : 김원재</p>
          </div>
        </div>
      </div>
      <div class="shortcut-container">
        <p class="f-info">
          본 쇼핑몰은 청소년 유해상품 취급 특성상
          <strong>만 19세 이상 성인만 이용 가능</strong>하며,<br />주문 시
          본인인증 및 성인확인이 진행될 수 있습니다.
        </p>
        <div>
          <a href="http://pf.kakao.com/_SxgVFn" target="_blank"
            ><img src="@/assets/kakao_icon.png"
          /></a>
          <a href="https://instagram.com/necokumo" target="_blank"
            ><img src="@/assets/insta_icon.png"
          /></a>
          <a href="https://youtube.com/@necokumo" target="_blank"
            ><img src="@/assets/youtube_icon.png"
          /></a>
        </div>
      </div>
    </footer>
    <div class="floating-container" v-show="showTopButton">
      <a href="http://pf.kakao.com/_SxgVFn" target="_blank">
        <img src="@/assets/kakao_floating.gif" width="48px" height="48px" />
      </a>
      <button @click="scrollToTop">
        <Icon size="24" color="#000000">
          <ArrowUp48Regular />
        </Icon>
      </button>
    </div>
  </div>
</template>

<script setup lang="js">
import { getUserId, logoutProcess } from "@/lib/auth";
import { db } from "@/lib/firebase";
import { Icon } from "@vicons/utils";
import { ArrowUp48Regular } from "@vicons/fluent";
import router from "@/router";
import {
  doc,
  updateDoc,
  Timestamp,
  getDocs,
  query,
  collection,
  where,
  orderBy,
} from "firebase/firestore";
import { computed, ref, onMounted, watch, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const categoryDatas = ref([]);
const subCategoryDatas = ref([]);
const currentUser = ref(null);
const searchKeyword = ref("");

// --- TOP_TEXT_BANNER (헤더 텍스트 배너용)
const topTextBannerDatas = ref([]);

const showTopButton = ref(false);

const route = useRoute();

// --- 공통: docs -> 배열 변환
const mapDocs = (snapshot) =>
  snapshot.docs.map((d) => ({
    id: d.id,
    ...d.data(),
  }));

// --- 공통: 외부 링크 여부 (템플릿에서 사용)
const isExternalLink = (url) => {
  if (!url || typeof url !== "string") return false;
  return url.startsWith("http://") || url.startsWith("https://");
};

const handleScroll = () => {
  showTopButton.value = window.scrollY > 200; // 200px 이상 내려가면 표시
};

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

// --- 카테고리 조회 (상위)
async function fetchParentCategories() {
  try {
    const snap = await getDocs(
      query(
        collection(db, "category"),
        where("categoryGrade", "==", 0),
        orderBy("categoryOrder", "asc")
      )
    );

    categoryDatas.value = snap.docs
      .filter((d) => d.id !== "1")
      .map((d) => ({
        id: d.id,
        title: d.data().categoryName,
      }));
  } catch (error) {
    console.error("상위 카테고리 조회 실패:", error);
    categoryDatas.value = [];
  }
}

// --- 서브카테고리 조회
async function fetchSubCategories(categoryId) {
  try {
    if (!categoryId) {
      subCategoryDatas.value = [];
      return;
    }

    const snap = await getDocs(
      query(
        collection(db, "category"),
        where("categoryParentId", "==", String(categoryId)),
        orderBy("categoryOrder", "asc")
      )
    );

    subCategoryDatas.value = snap.docs
      .filter((d) => d.id !== "1")
      .map((d) => ({
        id: d.id,
        title: d.data().categoryName,
      }));
  } catch (error) {
    console.error("서브 카테고리 조회 실패:", error);
    subCategoryDatas.value = [];
  }
}

// --- TOP_TEXT_BANNER 조회
async function fetchTopTextBanners() {
  try {
    const snap = await getDocs(
      query(
        collection(db, "banners"),
        where("category", "==", "TOP_TEXT_BANNER"),
        orderBy("order", "asc")
      )
    );

    topTextBannerDatas.value = mapDocs(snap);
    console.log(topTextBannerDatas.value);
  } catch (error) {
    console.error("TOP_TEXT_BANNER 조회 실패:", error);
    topTextBannerDatas.value = [];
  }
}

// --- 현재 유저 처리 + 방문일 갱신
async function fetchAndTouchCurrentUser() {
  try {
    const userId = getUserId();
    if (!userId) {
      currentUser.value = null;
      return;
    }

    currentUser.value = userId;

    await updateDoc(doc(db, "users", userId), {
      visitedAt: Timestamp.fromDate(new Date()),
    });
  } catch (error) {
    console.error("유저 방문일 갱신 실패:", error);
  }
}

onMounted(async () => {
  try {
    window.addEventListener("scroll", handleScroll);
    await Promise.all([
      fetchParentCategories(),
      fetchTopTextBanners(),
      fetchAndTouchCurrentUser(),
    ]);

    await fetchSubCategories(route.query.category);
  } catch (error) {
    console.error("헤더 초기화 실패:", error);
  }
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});

const isLogged = computed(() => currentUser.value !== null);

const logout = async () => {
  await logoutProcess();
  window.location.href = "/";
};

const handleSearch = () => {
  const keyword = searchKeyword.value.trim();

  if (!keyword) {
    alert("검색어를 입력하세요.");
    return;
  }

  const encodedKeyword = encodeURIComponent(keyword);
  router.push(`/search?keyword=${encodedKeyword}`);
};

// --- 카테고리 변경 시 서브카테고리 재조회
watch(
  () => route.query.category,
  async (newVal, oldVal) => {
    if (newVal === oldVal) return;
    await fetchSubCategories(newVal);
  }
);
</script>

<style lang="scss" scoped>
.consumer-layout {
  > .main-header {
    position: sticky;
    top: 0;
    z-index: 20;
    background: white;
    width: 100%;
    box-shadow: 0px 2px 6px rgba($color: #000000, $alpha: 0.25);

    > .header {
      height: 36px;
      display: flex;
      align-items: center;
      overflow: hidden;
      min-width: 1200px;

      .top-text-banner-swiper {
        width: 100%;
        height: 100%;
      }

      :deep(.swiper-slide) {
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      a {
        display: block;
        width: 100%;
        height: 100%;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        font-weight: 600;
        text-decoration: none;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    > hr {
      border: none;
      border-bottom: 1px solid #efefef;
    }

    > header {
      padding: 16px 24px;
      margin: auto;
      max-width: 1200px;
      min-width: 1200px;

      > .main-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;

        > .home-btn {
          > img {
            width: 128px;
          }
        }

        > .search-bar {
          padding: 8px 16px;
          width: 360px;
          border-radius: 100rem;
          border: 1px solid black;
          display: flex;
          align-items: center;
          gap: 8px;
          height: 44px;

          > input {
            flex: 1;
            height: 100%;
            font-size: 16px;
            border: none;

            &:focus {
              outline: none;
            }
          }

          > button {
            background: none;
            border: none;
            cursor: pointer;
          }
        }

        > .user-info {
          display: flex;
          align-items: center;
          gap: 36px;

          > a,
          button {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 4px;
            background: none;
            border: none;
            cursor: pointer;

            > span {
              font-size: 36px;
            }

            > p {
              font-size: 14px;
            }
          }
        }
      }

      > hr {
        margin: 16px 0;
        border: none;
        border-top: 1px solid #efefef;
      }

      > .category-container {
        > .main-category-nav {
          display: flex;
          align-items: center;
          gap: 24px;
          > a {
            font-weight: 700;
            font-size: 18px;

            &:hover {
              color: #007bff;
            }
          }
        }

        > .sub-category-nav {
          margin-top: 16px;
          display: flex;
          align-items: center;
          gap: 24px;
          > a {
            font-weight: 500;

            &:hover {
              color: #007bff;
            }
          }
        }
      }
    }
  }

  > footer {
    background-color: #1c1c1c;
    > div.footer-content {
      margin: auto;
      min-width: 1200px;
      padding: 64px 24px 36px;
      display: flex;
      max-width: 1200px;
      justify-content: space-between;
      gap: 16px;
      color: white;

      > div {
        > img {
          width: 128px;
          margin-bottom: 24px;
          filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg)
            brightness(102%) contrast(102%);
        }

        p.f-info {
          line-height: 1.75;
          font-size: 14px;
          &.mt {
            margin-top: 8px;
          }
        }

        p.f-cont {
          font-size: 16px;
          font-weight: 700;
          &.mt {
            margin-top: 8px;
          }
        }

        &:nth-child(2) {
          display: flex;
          gap: 24px;

          > div {
            > h2.mt {
              margin-top: 8px;
            }

            > h3.mt {
              margin-top: 24px;
            }
          }
        }
      }
    }

    > div.shortcut-container {
      border-top: 1px solid #333;
      padding: 36px 24px 64px;
      display: flex;
      justify-content: space-between;
      margin: auto;
      min-width: 1200px;
      max-width: 1200px;
      color: white;

      p.f-info {
        line-height: 1.5;
        font-size: 14px;
        &.mt {
          margin-top: 8px;
        }

        > strong {
          color: #ff55b3;
        }
      }

      > div {
        display: flex;
        gap: 16px;

        > a {
          > img {
            height: 24px;
          }
        }
      }
    }
  }

  > .floating-container {
    position: fixed;
    bottom: 24px;
    right: 24px;
    z-index: 100;
    display: flex;
    flex-direction: column;
    gap: 8px;

    > a {
      border-radius: 50%;

      > img {
        border-radius: 50%;
        box-shadow: 0 0 4px rgba($color: #000000, $alpha: 0.5);
      }
    }

    > button {
      cursor: pointer;
      border-radius: 50%;
      border: none;
      outline: none;
      width: 48px;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: white;
      box-shadow: 0 0 4px rgba($color: #000000, $alpha: 0.5);
    }
  }
}
</style>
